/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-props-no-spreading */
import React, { FC, useEffect, useState } from 'react';

import './scalableImage.scss';

export const scalableImageWidths = ["1920", "1600", "1440", "1366", "1024", "960", "768", "640", "480", "320"];

interface ScalableImageProps extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>{
	src?: string;
	desktopWidth?:number;
	mobileWidth?:number;
	fetchPriority?: 'high' | 'low' | 'auto';
}
const ScalableImage: FC<ScalableImageProps> = ({
	src,
	desktopWidth = 100,
	mobileWidth,
	...props
}) => {

	const [srcSet, setSrcSet] = useState("");

	useEffect(() => {
		if(src === undefined) return;
		const scales = scalableImageWidths.map((width) => 
			`${src}?tr=w-${width} ${width}w`
		);
		setSrcSet(scales.join(", "));
	}, [src]);
	
	return (
		<img src= {src} {...props}  srcSet={srcSet} sizes={`(max-width: 600px) ${mobileWidth??desktopWidth}vw, ${desktopWidth}vw`}/>
	);
};

export default ScalableImage;